var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabs },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "优惠券", name: "1" } },
            [_c("CouponTables")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "现金红包", name: "2" } },
            [_c("CashTables")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }